import React, { type ReactElement } from 'react';
import { Radio as AntRadio, type RadioProps as AntRadioProps } from 'antd';

export interface RadioProps extends AntRadioProps {}

export default function Radio({ ...rest }: RadioProps): ReactElement {
  return <AntRadio {...rest} />;
}

Radio.Group = AntRadio.Group;

Radio.Button = AntRadio.Button;
